import { render, staticRenderFns } from "./CompSocialNetworkInteractionsBig.vue?vue&type=template&id=47533184&scoped=true"
import script from "./CompSocialNetworkInteractionsBig.vue?vue&type=script&setup=true&lang=js"
export * from "./CompSocialNetworkInteractionsBig.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47533184",
  null
  
)

export default component.exports